<template>
	<div>
		<tyc :tqobj='tqobj'></tyc>
		<el-dialog class='gDia' :title="$t('lin_global.bjwl')" v-model="showEdit">
			<el-form :model="form" label-width="100px">
				<el-form-item :label="$t('lin_global.name')">
					<el-input v-model="form.name" style="width:80%"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lin_global.risk_desc')">
					<el-input type="textarea" v-model="form.desc" style="width:80%"></el-input>
				</el-form-item>
				<!-- <el-form-item :label="$t('lin_global.risk_type')">
					<el-select v-model="form.messageId" filterable clearable :placeholder="$t('lin_global.wxzyjlx')">
						<el-option v-for="item in areaList" :label="item.informname" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('lin_global.wllx')" style='background:none;'>
					<!-- <el-radio-group v-model="form.wtype" @change="change2">
						<el-radio label="0">{{$t('lin_global.jwd')}}</el-radio>
						<el-radio label="1">{{$t('lin_global.city')}}</el-radio>
					</el-radio-group> -->
					<el-radio class="radio" v-model="wtype" label="0">{{$t('lin_global.jwd')}}</el-radio>
  				<el-radio class="radio" v-model="wtype" label="1">{{$t('lin_global.city')}}</el-radio>
					<el-checkbox  v-show='wtype == 1' v-model="isProv">{{$t('app_onlyprov')}}</el-checkbox>
				</el-form-item>

				<el-form-item v-if='wtype == 0' :label="$t('lin_global.risk_radius')">
					<el-input v-model="form.radius" style="width:80%">
						<template slot="append">{{$t('lin_global.danweikm')}}</template>
					</el-input>

					<div>{{$t('lin_global.weilanshuoming')}}</div>
				</el-form-item>

				<el-form-item v-else :label="$t('lin_global.cityName')">
				<!-- <el-input v-model="citys2" style="width:80%"></el-input>-->
				<el-cascader
						v-if='!isProv'
						expand-trigger="hover"
						:options="options2"
						v-model="form.city"
						@change = "selEvent2"
						:show-all-levels="false"
					></el-cascader>
					<el-select v-else v-model="selVl" :placeholder="$t('app_select')">
						<el-option
							v-for="item in options2"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				

				<el-form-item>
					<el-button @click="showEdit = false">{{$t('lin_btn.cancel')}}</el-button>
					<el-button type="primary" @click="submit2">{{$t('lin_btn.submit')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	  <el-button @click="showEdit = true" style="" type='primary'>{{$t('lin_global.bjwl')}}</el-button>
	  

		<!-- <div class='gPageBorder gTopMg'>
			
			<p class='gPTitle'>{{$t('terminal.details.base_info')}}</p>

			 <el-row class=' gTopMg'>
		      <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.wlmc') ">
		            {{ riskInfo.controlName}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowRightForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.wllx') ">
		            
		            {{ riskInfo.controlType == '0' ? this.$t('lin_global.jwd'):this.$t('lin_global.city')}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.risk_type') ">
		            {{ riskInfo.messageName}}
		          </el-form-item>
		        </el-form>
		      </el-col>


		      <el-col :span='12'>
		        <el-form class='gShowRightForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.remark') ">
		            {{ riskInfo.controlDesc}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12' v-show='!ifShow'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.city') ">
		            {{ riskInfo.city ? riskInfo.city.split(',')[0] : ''}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col v-show='!ifShow' :span='12'>
		        <div class='gSfSp'></div>
		      </el-col>

		      <el-col :span='12' v-show='ifShow'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.risk_radius') ">
		            {{ riskInfo.radius}}
		          </el-form-item>
		        </el-form>
		      </el-col>
		  </el-row>


		</div> -->

		<div v-show="true" class='gPageBorder gTopMg'>
			<div style='display:inline-block;width:calc(100% - 48px);height:100%;margin-bottom:0px;background:none;padding:0 0px 12px 24px'>
				<div style='height:64px;'>
					<button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;text-align:left;'>{{riskInfo.controlName}}</button>
				</div>
				<div style='height:40px;'>
					<table id='rsdtb'>
						<tr>
							<td>
								<label class='dt-word-title'>{{$t('lin_global.wlmc')}}：</label>
								<label style="white-space: nowrap;text-overflow: ellipsis;max-width:70%;height:14px;overflow:hidden;display:inline-block;" class='dt-word-main'>{{riskInfo.controlName}}</label>
							</td>
							<td>
								<label class='dt-word-title'>{{$t('lin_global.wllx')}}：</label>
								<label class='dt-word-main'>{{ riskType[riskInfo.controlType]}}</label>
							</td>
							<td>
								<label class='dt-word-title'>{{$t('lin_global.risk_city')}}：</label>
								<label class='dt-word-main'>{{ riskInfo.city ? riskInfo.city.split(',')[0] : ''}}</label>
							</td>
							<td>
								<!-- <label class='dt-word-title'>{{$t('lin_global.risk_type')}}：</label>
								<label class='dt-word-main'>{{riskInfo.messageName}}</label> -->
							</td>
						</tr>
					</table>
				</div>

				<div style='min-height:20px;'>
					<table id='rsdtb'>
						<tr>
							<td style="width: 100%;">
								<label class='dt-word-title'>{{$t('app_wldesc')}}：</label>
								<label style="" class='dt-word-main'>{{ riskInfo.controlDesc}}</label>
							</td>
							
						</tr>
					</table>
				</div>
			
			</div>
		</div>

		

	  <div class='gPageBorder gTopMg'>
		<p class='gPTitle'>{{$t('lin_global.bdsb')}}</p>

			<el-row>
				<el-col :span="9">
					<div class="gSgLeftBtn">
						<el-button @click="addBind" style="" type='primary'>{{$t('lin_global.tjbd')}}</el-button>
						<el-button @click="batchUnBind" class='' type="" style="">{{$t('lin_btn.unbindAll')}}</el-button>
					</div>
				</el-col>

				<el-col :span="5">
					<div class='gCtrl'> 
						<!-- <MechanismSelector style='width:100%;' :data="mechanismData" ></MechanismSelector> -->
					</div>
				</el-col>

				<el-col :span="5">
					<div class="gCtrl">
						<MechanismSelector style='width:100%;' :data="mechanismData" ></MechanismSelector>
					</div>
				</el-col>

				<el-col :span="5">
					<div class="gSideCtrl">
						<el-input  :placeholder="$t('app_terNo')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input>
					</div>
				</el-col>

			</el-row>

		<el-table
	  	:data="arrdata"
			class='gTopMg'
			@sort-change='sortChange'
	  	border
	  	@selection-change="handleSelectionChange"
	  	style="">
	  		<el-table-column
	  		type="selection"
	  		width="55">
	  		</el-table-column>
	  		<el-table-column
	  		prop="terminalName"
				sortable="custom"
        :label="$t('lin_global.label_name')">
	  		</el-table-column>
	  		<el-table-column
	  		prop="terminalNo"
				sortable="custom"
        :label="$t('lin_global.label_no')"
	  		width="180">
	  		</el-table-column>
	  		<el-table-column
	  		prop="distributorName"
        :label="$t('lin_global.label_areaid')">
	  		</el-table-column>
	  		<el-table-column
	  		prop="bindingtime"
				sortable="custom"
        :label="$t('terminal.appList.label_time')"
	  		width="180">
	  		</el-table-column>

	  		<el-table-column
          :label="$t('lin_global.ope')">
				<template slot-scope="scope">
					<!-- <el-button @click.stop="unBind(scope.row.terminalid)" type="text">{{$t('lin_btn.unbind')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.unbind')" placement="top">
						<el-button type='text'  @click.stop="unBind(scope.row.terminalid)"><i class="fa fa-chain-broken" style="color:#FF4949"></i></el-button>
					</el-tooltip>
				</template>
	  		</el-table-column>
	  	</el-table>
	  	<div class="gPgDiv">
	  	  
		  <el-pagination
		    class='gPg'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords"
		    style="float: right;">
		  </el-pagination>
		</div>
	  </div>

	

		<el-dialog :title="$t('lin_global.bdsb')" class='gDia' v-model="dialogTopMgVisible" @close='closeBindAlert'>
			<el-row :gutter="16" style="margin-bottom: 20px;">
				<el-col :span="6">
		        	<!-- <el-select v-model="value1" @change="statusChange" placeholder="">
			          <el-option v-for="item in areaList1" :label="item.mechanismname" :value="item.mechanismid">
	                       </el-option>
			        </el-select> -->
							<div style='margin-left:16px;'><MechanismSelector style='width:100%;' :data="mechanismData1"></MechanismSelector></div>
				</el-col>
				<el-col :span="6">
		        	<el-select v-model="tstVl" @change="statusChange" placeholder="">
			          <el-option v-for="(item,index) in tstatus" :key="index" :label="item.lb" :value="item.vl">
	                       </el-option>
			        </el-select>
				</el-col>
				<el-col :span="6">
			        <el-input
		  			  :placeholder="$t('lin_global.label_no')"
		  			  icon="search"
		  			  v-model="input1"
		  			  :on-icon-click="handleIconClick"
		  			  @keyup.enter.native="focusEvent(handleIconClick)">
		  			</el-input>
		        </el-col>
		        <el-col :span="6">
			     	<el-button type="primary" @click="batchBindRow" >{{$t('lin_btn.bindAll')}}</el-button>
		        </el-col>
			</el-row>
			
			<el-table
	  	:data="arrdata1"
	  	border
	  	style="width:2000px;"
	  	@selection-change="handleSelectionChange1">
	  		<el-table-column
	  		type="selection"
	  		width="55">
	  		</el-table-column>
	  		<el-table-column
	  		prop="terminalName"
	  		:label="$t('lin_global.label_name')"
	  		width="">
	  		</el-table-column>
	  		<el-table-column
	  		prop="terminalNo"
        :label="$t('lin_global.label_no')"
	  		width="">
	  		</el-table-column>
        <el-table-column
          :label="$t('lin_global.status')"
          width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('lin_global.online')}}</el-tag>
            <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('lin_global.offline')}}</el-tag>
            <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('lin_global.new_add')}}</el-tag>
						<el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
          </template>
        </el-table-column>
	  		<el-table-column
	  		prop="mechName"
        :label="$t('lin_global.label_areaid')"
	  		width="">
	  		</el-table-column>
	  		<el-table-column
          :label="$t('lin_global.ope')">
				<template slot-scope="scope">
					<!-- <el-button @click.stop="bindRow(scope.row.terminalId)" type="text">{{$t('lin_btn.bind')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.bind')" placement="top">
						<el-button type='text' @click.stop="bindRow(scope.row.terminalId)"><i class="fa fa-chain" style=""></i></el-button>
					</el-tooltip>
				</template>
	  		</el-table-column>
	  	</el-table>
	  	
			<div style="margin-top: 20px;float: right;margin-bottom: 20px;">
				<el-pagination
					@size-change="handleSizeChange1"
					@current-change="handleCurrentChange1"
					:current-page="currentPage1"
					:page-sizes="[10,50,100]"
					:page-size="pageSize1"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalRecords1">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>
<style>
	#rsdtb{
		width: 100%;
	}
  #rsdtb td{
		float:left;
		width:33.333%;
	}
</style>

<script>
	import axios from 'axios'
	import {baseurl,focusEvent} from '../../api/url'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import city from '../city.js'
	import tyc from '@/components/global/tyc.vue'

	export default{
		components: {
			MechanismSelector,tyc
		},
		data(){
			var that = this
			return{
				mechanismData: {
          callback (value) {
            // that.value1 = value
						// that.statusChange(value)
						that.lMech = value
						that.getList(this.currentPage)
          }
				},
				mechanismData1: {
          callback (value) {
            that.value1 = value            
            that.statusChange()																	
          }
				},
				selVl: '',
				tqobj: '',
				tstatus: '',
				tstVl: '',
				queryKey: '',
				form: {
					name: '',
					desc: '',
					city: '',
					radius: ''
				},
				isProv: false,
				wtype: '1',
				lMech: '',
				showEdit: false,
				options2: city,
				focusEvent: focusEvent,
				input1:'',
				value1: '',
				areaList1: [],
				dialogFormVisible:false,
				dialogTopMgVisible:false,
				ifshow:true,
				ifShow:true,
				riskId:this.$route.params.id,
				riskInfo:{},
				areaList:[],
				radius:'',
				citys:'',
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				currentPage1: 1,
				pageSize1: 10,
				totalRecords1: 0,
				form:{
					controllerName:'',
					controllerDesc:'',
					messageId:'',
					controlType:''
				},
				params:{},
				arrdata:[],
				arrdata1:[],
				multipleSelection: [],
				multipleSelection1: [],
				orderType: '',
				orderName: '',
				riskType: {
					'0': this.$t('lin_global.jwd'),
					'1': this.$t('lin_global.city'),
					'2': this.$t('lin_global.shengfen')
					
				}
			}
		},
		created(){
			
			this.getDetail();
			this.getAd();
			this.getList(1);
			this.getData(1,'','');
			this.getAd1()
		},
		mounted () {
			
			var _this = this
			this.tqobj = {
				keys: ['terminalTypes'],
				callback: data => {
					_this.tstatus = data[0]
					console.log('fff', _this.tstatus)
				}
			}
		},
		methods:{
			closeBindAlert () {
        var _this = this
        this.mechanismData1 = {
          callback (value) {
			      _this.value1 = value            
            _this.statusChange()
          }
        }
        this.value1 = '' 
        this.tstVl = ''
        this.input1 = ''
        this.dialogTopMgVisible = false
      },
			bindRqs (id, isForce) {
        var params = {riskId:this.riskId,terminalId:id,status:'0', force: isForce?'1':'0'}
        axios.post(`${baseurl}/risk/bindingTerminal.do`,params).then(res=>{
          if (res.data.status == '200') {
						this.$message.success(this.$t('lin_global.bdcg'))    
						this.getList(this.currentPage)    
						this.closeBindAlert()
						
          } else if (res.data.status == 300) {
            // var _this = this
            this.$showConfirm(
              this.$t("app_tip"),
              res.data.message,
              this.$t("app_sure"),
              this.$t("app_cancel"),
              "warning",
              () => {                
                this.bindRqs(id, true)
              },"")                
          } else  {
            this.$message.error(res.data.message)
          }
        })
      },
			sortChange (a) {
        switch(a.prop){
          case 'terminalName':
            this.orderName = '1'
            break
          case 'terminalNo':
            this.orderName = '2'
            break
          case 'bindingtime':
            this.orderName = '3'
            break
        }
        this.orderType = a.order == 'descending'? 'desc':'asc'
				this.getList(this.currentPage)
      },
			query () {
				// this.getData(1, this.qeuryKey,'');
				this.getList(this.currentPage)
			},
			submit2 () {
        this.params = {
					id:this.riskId
				};
        if(this.wtype == '0'){
          this.params.radius = this.form.radius;
          this.params.controllerName = this.form.name;
          this.params.controllerDesc = this.form.desc;
          this.params.messageId = this.form.messageId;
          this.params.controlType = this.wtype;

          if (isNaN(Number(this.form.radius)) || Number(this.form.radius) <= 0.5) {
            this.$message.error(this.$t('app_rdneedmore') + '0.5') 
            return
          }
        }else{
          var cname = ''
          var tmpsub = []
          if (!this.isProv) {
						//child
						var fcode = this.form.city[0]
          	var scode = this.form.city.length == 2? this.form.city[1]:''
            city.forEach(item => {
              if (item.value == fcode) {
                item.children.forEach(sitem => {
                  if (sitem.value == scode) {
                    //// 
                    cname = sitem.province==sitem.label? sitem.label : sitem.province+sitem.label
                    return
                  }
                })
              }
            })
          } else {
            //p
            this.wtype = '2'
            city.forEach(item => {
              if (item.value == this.selVl) {
                cname = item.label
                return
              }
            })
          }
          this.params.city = cname + ',' + (this.isProv? this.selVl:this.form.city.toString());
					// this.params.city = this.form.city;
					
				
					
          this.params.controllerName = this.form.name;
          this.params.controllerDesc = this.form.desc;
          this.params.messageId = this.form.messageId;
          this.params.controlType = this.wtype;
        }
       
        if (!this.params.city && ((this.wtype=='1' && this.wtype=='2') || this.form.controlType=='undefined')) {
          this.$message(this.$t('lin_global.risk_city'))
          return 
				}
				
				if (typeof this.params.city !== 'string') {
					this.params.city = this.riskInfo.city
				}

        var params = this.params;
        axios.post(`${baseurl}/risk/editRisk.do`,params).then(res=>{
          //console.log("打印看看编辑返回信息")
          //console.log(res.data);
          if(res.data.status == 200){
            
            this.form.city = ''
            this.params.city = ''

            this.showEdit = false;
            this.$message.success(res.data.message);
						// this.getData(1,'','');
						this.getDetail()
          }else{
            this.showEdit = false;
            this.$message.error(res.data.message)
          }
        })
      },
			selEvent2:function(val){
				return
        // var result = val.toString().split(',');
        // var arr = this.options2.filter(v => {
        //   if(this.hasValue(result,v,"value")){
        //     if (v.children && v.children.length > 0) {
        //       v.children = v.children.filter(child => {
        //         if (this.hasValue(result,child,"value")) {
        //           return child
        //         }
        //         return false;
        //       });
        //       return v
        //     } else {
        //       return v
        //     }
        //   }
        // })

        // if(arr[0].value === "110000" || arr[0].value === "120000" || arr[0].value === "310000" || arr[0].value === "500000"){
        //   this.form.city = arr[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
        // }else{
        //   this.form.city = arr[0].label + arr[0].children[0].label + "," + arr[0].value + "," + arr[0].children[0].value;
        // }
			},
			hasValue:function(result,v,name){
        if (!v[name] || v[name] === "") {
          return true;
        }
        return result.some((re) => v[name] === re);
      },
			batchUnBind(){
				this.$confirm(this.$t('lin_global.sfjxpljb'), this.$t('lin_btn.tips'), {
		          confirmButtonText: this.$t('lin_btn.confirm'),
		          cancelButtonText: this.$t('lin_btn.cancel'),
		          type: 'warning'
		        }).then(() => {
		          let ids = []
		          if (this.multipleSelection.length === 0) {
		            this.$message.error(this.$t('lin_global.qxzyjbdzd'))
		            return false
		          }
		          for (let i = 0; i < this.multipleSelection.length; i++) {
		            ids.push(this.multipleSelection[i].terminalid)
		          }
		          let rq = ids.join(',');
		          var params = {riskId:this.riskId,terminalId:rq,status:'1'};
		          axios.post(`${baseurl}/risk/bindingTerminal.do`,params).then(res=>{
			    		//console.log("打印类型")
			    		//console.log(res.data.data)
			    		if (res.data.status == '200') {
			              this.$message.success(this.$t('lin_global.jbcg'))
			              this.getList(1);
			              this.dialogTopMgVisible = false;
			            } else {
			            	this.$message.error(res.data.message)
			            }
			    	})
		        }).catch(() => {

		        })
			},
			unBind:function(id){
				var params = {riskId:this.riskId,terminalId:id,status:'1'}
				this.$confirm(this.$t('lin_global.sfjbczd'), this.$t('lin_btn.tips'), {
		          confirmButtonText: this.$t('lin_btn.confirm'),
		          cancelButtonText: this.$t('lin_btn.cancel'),
		          type: 'warning'
		        }).then(() => {
		        	axios.post(`${baseurl}/risk/bindingTerminal.do`,params).then(res=>{
			    		//console.log("打印类型")
			    		//console.log(res.data.data)
			    		if (res.data.status == '200') {
			              this.$message.success(this.$t('lin_global.jbcg'))
			              this.getList(1);
			              this.dialogTopMgVisible = false;
			            } else {
			            	this.$message.error(res.data.message)
			            }
			    	})
		        })
			},
			batchBindRow(){
        if (this.multipleSelection1.length === 0) {
          this.$message.error(this.$t('lin_global.qxzybddzd'))
          return false
        }else{
          this.$confirm(this.$t('lin_global.sfjxplbd'), this.$t('lin_btn.tips'), {
            confirmButtonText: this.$t('lin_btn.confirm'),
            cancelButtonText: this.$t('lin_btn.cancel'),
            type: 'warning'
          }).then(() => {
            let ids = []

            for (let i = 0; i < this.multipleSelection1.length; i++) {
              ids.push(this.multipleSelection1[i].terminalId)
            }
            let rq = ids.join(',');
            this.bindRqs(rq)
          
          })
        }

			},
			bindRow(id, isForce){				
				this.$confirm(this.$t('lin_global.sfbdczd'), this.$t('lin_btn.tips'), {
		          confirmButtonText: this.$t('lin_btn.confirm'),
		          cancelButtonText: this.$t('lin_btn.cancel'),
		          type: 'warning'
		        }).then(() => {
							this.bindRqs(id)		        
		    })
			},
			getData (page,no,areaid){
				
				var tNo = this.input1 ? this.input1 : ''

				this.currentPage1 = page;
				var status = this.tstVl
				
				//console.log("打印传出参数");
				//console.log(params);
				this.$unbindDevices(page, this.pageSize1, areaid, this.riskId, status, tNo, (res) => {
				  if (res.status === 200) {
						this.arrdata1 = res.data;
		        this.totalRecords1 = res.total;
					} else {
						this.$message.error(res.message)
					}
				}, (error) => {
					this.$message.error(this.$t('app_rqsError'))
				})

			
			},
			statusChange(){
		    	this.getData(1,this.input1,this.value1)
		    },
		     handleIconClick(){
		    	this.getData(1,this.input1,this.value1)
		    },
			getAd1:function(){
		    	var params = {page:1,rows:10000};
		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
		    		//console.log(res.data);
		    		var obj={
		    			'mechanismname':this.$t('lin_global.all_mechanism'),
		    			'mechanismid':''
		    		}
		    		this.areaList1 = res.data.data;

		    		this.areaList1.unshift(obj)
		    	})
		    },
			addBind:function(){
				this.dialogTopMgVisible = true;
				this.statusChange()
			},
			submit:function(){
				this.params = {};
				if(this.form.controlType=='0'){
					this.params.id = this.riskId;
					this.params.radius = this.radius;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
					this.params.controlType = this.form.controlType;
				}else{
					this.params.id = this.riskId;
					this.params.city = this.citys;
					this.params.controllerName = this.form.controllerName;
					this.params.controllerDesc = this.form.controllerDesc;
					this.params.messageId = this.form.messageId;
					this.params.controlType = this.form.controlType;
				}
				//console.log("打印参数");
				//console.log(this.params);
				var params = this.params;
				axios.post(`${baseurl}/risk/editRisk.do`,params).then(res=>{
			            //console.log("打印看看编辑返回信息")
			            //console.log(res.data);
			            if(res.data.status == 200){
			            	this.dialogFormVisible = false;
			            	this.$message.success(res.data.message);
			            	this.getDetail();
			            }else{
			            	this.dialogFormVisible = false;
			            	this.$message.error(res.data.message)
			            }
			        })
			},
			change:function(){
			
			},
			handleSelectionChange(val){
		    	this.multipleSelection = val
		    },
		    handleSelectionChange1(val){
		    	this.multipleSelection1 = val
		    },
			onCancel:function(){
				this.dialogFormVisible = false;
			},
			getAd:function(){
		    	axios.post(`${baseurl}/risk/getMessageInform.do`,{}).then(res=>{
		    		//console.log("打印类型")
		    		//console.log(res.data.data)
		    		this.areaList = res.data.data;
		    	})
		    },
		    handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getList(this.currentPage)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getList(this.currentPage)
		    },
		    handleSizeChange1: function (val) {
		        this.pageSize1 = val
		        this.getData(this.currentPage1,this.input1,this.value1)
		    },
		    handleCurrentChange1: function (val) {
		        this.currentPage1 = val
		        this.getData(this.currentPage1,this.input1,this.value1)
		    },
		    getList:function(page){
					this.currentPage = page;
					var tno = this.queryKey
					var mech = this.lMech
					//mechanismId
		    	var params = {orderName: this.orderName ,orderType: this.orderType,riskId:this.riskId,page:page,rows:this.pageSize, terminalNo: tno, mechanismId: mech}
		    	axios.post(`${baseurl}/risk/getByIdTerminalRisk.do`,params).then(res=>{
		            this.arrdata = res.data.data;
		            this.totalRecords = res.data.total;
		        })
		    },
			getDetail () {
				var params = {riskId:this.riskId};
				axios.post(`${baseurl}/risk/getByIdRisk.do`,params).then(res=>{
			        this.riskInfo = res.data.data;
			        this.form.name = res.data.data.controlName
							this.form.desc = res.data.data.controlDesc
							this.wtype = res.data.data.controlType
			        this.form.messageId = res.data.data.messageid;
			        if(res.data.data.controlType == '0'){
			        	this.form.radius = res.data.data.radius;
			        }else{
								// this.citys = res.data.data.city;
								
								var arr = res.data.data.city.split(',')
								if (arr.length == 3) {
									var city = []
									city.push(arr[1]);
									city.push(arr[2]);
									this.form.city = city
									this.isProv = false
								} else {
									this.selVl = arr[1]
									this.isProv = true
								}
                if (this.isProv) this.wtype = '1'
			        }
				})
			},
			edit:function(){
				this.dialogFormVisible = true;
				//this.form.controlType=='1'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// detail.vue?2b02ac2e